import { useMemo, useRef, useState } from "react";

export function useChat() {
  const CHAT_TOKEN_KEY = "byko-chat-token";
  const CHAT_DEPT_KEY = "byko-chat-department";
  const endpoint = "wss://webmessaging.mypurecloud.de/v1";

  const deploymentIds: Record<string, string> = useMemo(
    () => ({
      Þjónustuver: "ea233e4b-746b-4faa-93b3-b18cfae19507",
      Tækjaleiga: "efcb1c2b-b5e1-4161-b338-509d57adf28d",
    }),
    [],
  );

  const [open, setOpen] = useState(false);
  const [waitingForAgent, setWaitingForAgent] = useState(true);
  const [showDepartmentSelect, setShowDepartmentSelect] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState<string | null>(null);
  const [showDisconnectConfirm, setShowDisconnectConfirm] = useState(false);
  const [blockedFileTypes, setBlockedFileTypes] = useState<string[]>([]);
  const [maxFileSizeKB, setMaxFileSizeKB] = useState<number | null>(null);
  const [allowedFileTypes, setAllowedFileTypes] = useState<string[]>([]);
  const [fileError, setFileError] = useState<string>("");
  const socketRef = useRef<WebSocket | null>(null);

  return {
    state: {
      waitingForAgent,
      showDepartmentSelect,
      selectedDepartment,
      open,
      showDisconnectConfirm,
      blockedFileTypes,
      maxFileSizeKB,
      allowedFileTypes,
      fileError,
      CHAT_TOKEN_KEY,
      CHAT_DEPT_KEY,
      endpoint,
      deploymentIds,
      socketRef,
    },
    setWaitingForAgent,
    setShowDepartmentSelect,
    setSelectedDepartment,
    setOpen,
    setShowDisconnectConfirm,
    setBlockedFileTypes,
    setMaxFileSizeKB,
    setAllowedFileTypes,
    setFileError,
  };
}

export default useChat;
